import React, { FC, useEffect } from 'react'
import { Layout } from 'components/Layout'
import { useDispatch, useSelector } from 'react-redux'
import { State } from 'index'
import { ProductEditConfirmTemplate } from 'components/Templates'
import { getBread } from 'reducks/bread/selectors'
import { goBack } from 'connected-react-router'
import { getBreadShortName } from 'lib/helper'

const ProductEditConfirm: FC = () => {
  const path = useSelector((state: State) => state.router.location.pathname)
  const isEditPage = /\/product\/edit\/confirm\/.+/.test(path)

  const dispatch = useDispatch()

  const bread = useSelector((state: State) => getBread(state))

  useEffect(() => {
    if (!bread) dispatch(goBack())
  }, [bread])

  return (
    <Layout title={isEditPage && bread ? `確認｜${getBreadShortName(bread)}の編集` : '確認｜sacriで出品する商品の登録'}>
      <ProductEditConfirmTemplate isEditPage={isEditPage} />
    </Layout>
  )
}

export default ProductEditConfirm
